export default "__VITE_ASSET__BkcBBYnw__"